import type { RelatedTemplate } from "AdminPanel/Spine/store/configStore";

function skinNamesFromConfig(config: { skus?: Record<string, any> } | null | undefined): Set<string> {
  const names = new Set<string>();
  const skus = config?.skus || {};
  for (const sku of Object.values(skus)) {
    const skinName = (sku as { skinName?: string })?.skinName;
    if (skinName) names.add(skinName);
  }
  return names;
}

/**
 * 当前选中皮肤是否落在「带 spineData 的关联模版」上（动态 Spine）。
 * 普通模版编辑器混合预览用。
 */
export function relatedSelectionHasDynamicSpine(
  selectedSkins: string[],
  loadedRelatedTemplates: RelatedTemplate[] | undefined,
): boolean {
  if (!selectedSkins.length || !loadedRelatedTemplates?.length) return false;
  for (const rel of loadedRelatedTemplates) {
    if (!rel.spineData) continue;
    const names = skinNamesFromConfig(rel.config);
    if (selectedSkins.some((s) => names.has(s))) return true;
  }
  return false;
}

/**
 * Spine 编辑器：主模版或关联模版中，是否选中了动态 Spine 皮肤。
 */
export function spineEditorSelectionHasDynamicSpine(
  selectedSkins: string[],
  templateConfig: { skus?: Record<string, any> } | null | undefined,
  spineData: unknown | null | undefined,
  loadedRelatedTemplates: RelatedTemplate[] | undefined,
): boolean {
  if (!selectedSkins.length) return false;
  if (spineData && templateConfig) {
    const mainNames = skinNamesFromConfig(templateConfig);
    if (selectedSkins.some((s) => mainNames.has(s))) return true;
  }
  return relatedSelectionHasDynamicSpine(
    selectedSkins,
    loadedRelatedTemplates,
  );
}
